import React from 'react';
import { Phone, MessageCircle, Mail, MapPin, Clock, ExternalLink } from 'lucide-react';
import { companyInfo } from '../../data/mockData';

const tileStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '0.75rem',
  padding: '0.85rem',
  background: 'var(--bg-silvery)',
  borderRadius: '0.6rem',
  textDecoration: 'none',
  color: 'var(--text-primary)'
};

const Tile = ({ icon, title, subtitle, ...linkProps }) => (
  <a style={tileStyle} {...linkProps}>
    {icon}
    <div>
      <div style={{ fontWeight: 600, fontSize: '0.9rem' }}>{title}</div>
      <div style={{ fontSize: '0.825rem', color: 'var(--text-muted)' }}>{subtitle}</div>
    </div>
  </a>
);

export const ContactInfoCard = () => (
  <div className="contact-card" style={{ textAlign: 'left' }}>
    <h3 style={{ fontSize: '1.2rem', fontWeight: 700, color: 'var(--primary-navy)', marginBottom: '1.25rem' }}>
      Reach us directly
    </h3>

    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
      <Tile
        icon={<Phone size={18} style={{ color: 'var(--accent-gold-dark)' }} />}
        title="Call"
        subtitle={companyInfo.phone}
        href={`tel:${companyInfo.phone}`}
        data-testid="contact-phone"
      />
      <Tile
        icon={<MessageCircle size={18} style={{ color: '#25D366' }} />}
        title="WhatsApp"
        subtitle={companyInfo.whatsapp}
        href={`https://wa.me/${companyInfo.whatsappRaw}`}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="contact-whatsapp"
      />
      <Tile
        icon={<Mail size={18} style={{ color: 'var(--primary-navy)' }} />}
        title="Email"
        subtitle={companyInfo.email}
        href={`mailto:${companyInfo.email}`}
        data-testid="contact-email"
      />

      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem', padding: '0.85rem', background: 'var(--bg-silvery)', borderRadius: '0.6rem' }}>
        <MapPin size={18} style={{ color: 'var(--primary-navy)', marginTop: 2 }} />
        <div>
          <div style={{ fontWeight: 600, fontSize: '0.9rem' }}>Office</div>
          <div style={{ fontSize: '0.825rem', color: 'var(--text-muted)' }}>{companyInfo.address}</div>
        </div>
      </div>

      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem', padding: '0.85rem', background: 'var(--bg-silvery)', borderRadius: '0.6rem' }}>
        <Clock size={18} style={{ color: 'var(--primary-navy)', marginTop: 2 }} />
        <div style={{ fontSize: '0.825rem', color: 'var(--text-muted)', lineHeight: 1.6 }}>
          <div style={{ fontWeight: 600, fontSize: '0.9rem', color: 'var(--text-primary)' }}>Hours</div>
          Mon–Fri 9:00–18:00 · Sat 9:00–14:00
        </div>
      </div>
    </div>

    <button
      onClick={() => window.open(companyInfo.googleCalendarLink, '_blank')}
      className="btn-primary"
      style={{ width: '100%', marginTop: '1.25rem' }}
      data-testid="contact-schedule-cta"
    >
      <ExternalLink size={16} /> Schedule a Consultation
    </button>
  </div>
);
